import { createSlice } from "@reduxjs/toolkit"

export const brandListSlice = createSlice({
	name: "brand_list",
	initialState: {
		brand: "",
		errors: [],
	},

	reducers: {
        getBrand: (state, action) => {
            // console.log(action.payload)
			state.brand = action.payload
		},
		getBrandList: (state, action) => {
			state.brand = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getBrand, getBrandList, getErrors} = brandListSlice.actions

export default brandListSlice.reducer
